import { createProvider, createReadonlyProvider } from 'apprise-frontend-core/state/factory';
import { FileBoxConfiguration } from 'apprise-ui/filebox/filebox';

export type UIConfig = FileBoxConfiguration

export const [UIConfigProvider, useUIConfig] = createReadonlyProvider<UIConfig>()


// an interface for UI components to access preferences.
// needs an implementation to provide persistence.
export type Preferences<T extends Record<string, any> = Record<string, any>> = {

    isEnabled: () => boolean

    get: () => T

    set: (_: PreferenceUpdater<T>) => Promise<void>

}

export type PreferenceUpdater<T = Preferences> = (_: T) => void

// a no-op implementation (no preferences).
const initialPreferences: Preferences = { isEnabled: () => true, get: () => ({}), set: async () => { } }

export const [UIPreferencesProvider, usePreferenceProviderContext] = createProvider<Preferences>(initialPreferences)